export function useOgEvents() {
  const { getEventsCityPageTags } = useApiSeo();

  // COD-879: a city has OG events content when the SEO Events City endpoint
  // says its page is not fallback content (i.e. a kontent.ai page exists).
  // Fails closed: missing flag, missing cityId, or API errors hide the carousel.
  const hasOgEventsCityContent = async (cityId) => {
    if (!cityId) {
      return false;
    }

    const seoData = await getEventsCityPageTags(cityId).catch(() => null);

    return seoData?.isFallbackContent === false;
  };

  return { hasOgEventsCityContent };
}
